import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "教育",
  icon: "🧠",
  templates: [
    {
      title: "わかりやすく説明",
      content: `[ワクチンが免疫システムをどのように訓練するか]というトピックを、リスナーにとって明確で魅力的な方法で説明してください。
- [科学の知識がない好奇心旺盛なティーンエイジャー]に説明することを想像してください。
- 身近なたとえ話を使ってください：[避難訓練に例える — 本番に備えて練習するものだと]。
- 専門用語は避けてください。技術的な用語が必要な場合は、すぐに平易な言葉で定義してください。
- リスナーが賢いと感じられる、見下さない温かく励ましのあるトーンで書いてください。`
    },
    {
      title: "ドキュメンタリーナレーション",
      content: `ドキュメンタリー風のナレーションを書いてください。
- テーマ：[バンコクの屋台料理の売り手たちの日常生活]。
- 視点：[シンプルに見えるが習得に何年もかかる料理の背後にある技術、誇り、世代を超えた知識]。
- トーン：[敬意を込めた、鮮やかで、急がない — シーンに呼吸の余地を与える]。
- リスナーが環境を想像し感じるのに役立つ感覚的な描写を含めてください：[中華鍋のジューッという音、朝の市場の湿気、一万回繰り返してきた売り手の正確な手の動き]。
- 臨場感のために現在時制で書いてください。`
    },
    {
      title: "ガイド付き瞑想",
      content: `聴くためにデザインされたガイド付き瞑想のスクリプトを書いてください。
- 目的：[長い仕事の日の後の緊張をほぐし、穏やかに夜へと移行する]。
- リスナーを導いてイメージさせてください：[夕暮れ時の静かな湖畔 — 水面の温かい光、やさしいそよ風、遠くで夜を迎える鳥たちの声]。
- トーン：[穏やかで、急がず、地に足のついた]。
- 話す時間の目安：[8分]。
- 指示の間にたっぷりの自然な間（「...」で示す）を入れてください。文は短く優しくしてください。急激なエネルギーの変化は避けてください。`
    }
  ]
};
